import styled, { css } from 'styled-components'

export const Button = styled.button<{ $isVisible: boolean }>`
  all: unset;
  position: fixed;
  bottom: 3rem;
  right: 0;
  width: 6rem;
  height: 6rem;
  opacity: 1;
  transition: 0.4s opacity;
  cursor: pointer;
  border-radius: 3rem 0 0 3rem;
  background: white;
  z-index: 9100;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  ${(props) =>
    !props.$isVisible &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`
